import { render, staticRenderFns } from "./RejectForm.vue?vue&type=template&id=9c502cd8"
import script from "./RejectForm.vue?vue&type=script&lang=js"
export * from "./RejectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports